import type { DiagnosticError } from '@/services/performance-diagnostics'

export class OcrEngineFailure extends Error {
  constructor() { super('OCR engine prediction failed'); this.name = 'OcrEngineFailure' }
}

export function classifyOcrError(error: unknown): { code: DiagnosticError; resetEngine: boolean } {
  const name = error && typeof error === 'object' && 'name' in error && typeof error.name === 'string'
    ? error.name
    : ''
  if (name === 'AbortError' || name === 'OcrEngineResetError') return { code: 'cancelled', resetEngine: false }
  // Prediction timeouts already invalidate the engine inside OcrEngine.
  if (name === 'OcrPredictionTimeoutError') return { code: 'ocr-timeout', resetEngine: false }
  if (name === 'MxdcOcrTaskTimeoutError') return { code: 'ocr-timeout', resetEngine: true }
  if (name === 'OcrEngineFailure') return { code: 'ocr-engine-error', resetEngine: true }
  if (name === 'InvalidStateError' || name === 'IndexSizeError' || name === 'SecurityError') return { code: 'image-error', resetEngine: false }
  return { code: 'ocr-unknown-error', resetEngine: false }
}

export class OcrRecoveryBackoff {
  private failures = 0
  private retryAt = 0
  ready(now = Date.now()): boolean { return now >= this.retryAt }
  success(): void { this.failures = 0; this.retryAt = 0 }
  fail(now = Date.now()): number {
    this.failures = Math.min(this.failures + 1, 6)
    const delay = Math.min(30_000, 1_000 * 2 ** (this.failures - 1))
    this.retryAt = now + delay
    return delay
  }
}
